import { Select } from "antd";
import useAddressSearch from "../../../../hooks/useAddressSearch";
import { IFormAddressSelectProps } from "./IFormComponents";

const { Option } = Select;

const FormAddressSelect = ({
  fieldKey,
  targetField,
  label = "Dirección",
  mandatory = false,
  updateFn,
  initialValue,
  error,
  translations,
}: IFormAddressSelectProps) => {
  const {
    addressInputs,
    placePredictions,
    isPlacePredictionsLoading,
    handleSearchAddress,
    handleSelectAddress,
  } = useAddressSearch({ updateFn, fieldKey, initialValue });

  return (
    <div className="investor-form-item">
      <label
        className={`${mandatory ? "mandatory" : ""} ${
          error ? "error-input" : ""
        } `}
      >
        {label}
      </label>
      <Select
        style={{ width: "100%" }}
        showSearch
        value={addressInputs[fieldKey] || initialValue || undefined}
        placeholder={translations.searchAddress}
        onSearch={handleSearchAddress(fieldKey)}
        onChange={handleSelectAddress(fieldKey, targetField)}
        filterOption={false}
        notFoundContent={isPlacePredictionsLoading ? "Cargando..." : null}
        status={error ? "error" : undefined}
      >
        {/* 👇 Agregamos el valor inicial como opción para que AntD lo pueda mostrar */}
        {initialValue &&
          !placePredictions.some((p) => p.description === initialValue) && (
            <Option key="initial" value={initialValue}>
              {initialValue}
            </Option>
          )}

        {/* Renderizamos las opciones de Google Places */}
        {placePredictions.map((item: any) => (
          <Option key={item.place_id} value={item.description}>
            {item.description}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default FormAddressSelect;
